@if (data.headline || data.anchor) {
  <mb-section-headline
    class="headline-container"
    [headline]="data.headline"
    [anchor]="data.anchor"
    containerClass="container-sm"
  ></mb-section-headline>
}

<div class="container-xxl routes-container">
  @if (data.previewSmall || data.previewLarge) {
    <picture class="preview-picture">
      @if (data.previewLarge) {
        <source [srcset]="data.previewLarge" media="(min-width: 786px)" />
      }
      <img [src]="data.previewSmall || data.previewLarge" alt="map" />
    </picture>
  }
  <div class="collection-wrapper">
    <div class="container-sm collection-wrapper-container">
      <div class="route-collection-container">
        @for (collection of data.routes; track collection.day) {
          <div class="route-collection-item">
            <a class="btn btn-plain" [routerLink]="['test-routes', data.id]" [queryParams]="{ day: collection.day }">{{
              'DAY_N' | translate: { day: collection.day }
            }}</a>
            <span class="mb-badge mb-badge-small">{{ collection.routeCount }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
